import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function descriptionTabs() {
  const swiper = new Swiper('.swiper-container', {
    modules: [Autoplay],
    slidesPerView: 1,
    spaceBetween: 10,
    on: {
      slideChange: function () {
        const activeIndex = swiper.activeIndex;
        const buttons = document.querySelectorAll('.tab-title');
        buttons.forEach((btn, index) => {
          btn.classList.toggle('active', index === activeIndex);
        });
      },
      // slideChangeTransitionEnd: function () {
      //     const tabPanels = document.querySelectorAll(".tab-panel");
      //     const tabsSwiper = document.querySelector(".tabs.swiper-wrapper");
      //     tabPanels.forEach((tabPanel) => {
      //         if(tabPanel.classList.contains("swiper-slide-active")){
      //             let totalHeight = 0;
      //             const children = tabPanel.children;

      //             for (let i = 0; i < children.length; i++) {
      //                 totalHeight += children[i].getBoundingClientRect().height;
      //             }

      //             tabsSwiper.style.height = `${totalHeight}px`;
      //         };
      //     });
      // },
    },
  });

  const buttons = document.querySelectorAll('.tab-title');
  buttons.forEach((button, index) => {
    button.addEventListener('click', function () {
      buttons.forEach((btn) => btn.classList.remove('active'));
      this.classList.add('active');
      swiper.slideTo(index);
    });
  });
}
